export enum FirebaseProject {
  ProdV1 = "prod-v1",
  ProdV2 = "prod-v2",
  Staging = "staging",
}

export enum ServiceOrigin {
  Remote = "remote",
  Emulator = "emulator",
}

export enum ViteConfigMode {
  Development = "development",
  Staging = "staging",
  Production = "production",
}

export enum ViteConfigCommand {
  Serve = "serve",
  Build = "build",
}

export enum ViteRunCommand {
  Dev = "dev",
  Build = "build",
  Preview = "preview",
}

export enum AppName {
  All = "all",
  Vr = "vr",
  Mobile = "mobile",
  Portal = "portal",
  Bybcat = "bybcat",
}